import { render, staticRenderFns } from "./public-dialogue.vue?vue&type=template&id=69edc0aa&scoped=true&"
import script from "./public-dialogue.vue?vue&type=script&lang=js&"
export * from "./public-dialogue.vue?vue&type=script&lang=js&"
import style0 from "./public-dialogue.vue?vue&type=style&index=0&id=69edc0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69edc0aa",
  null
  
)

export default component.exports